import * as z from "zod";
//#region src/__generated__/external/profile/zod/confirmEmailChangeBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const confirmEmailChangeBodySchema = z.object({ token: z.uuid().describe("Токен из ссылки в письме на новый адрес") }).describe("Подтверждение смены email");
//#endregion
//#region src/__generated__/external/profile/zod/confirmEmailChangeSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const confirmEmailChangeStatus204Schema = z.unknown();
const confirmEmailChangeResponseSchema = confirmEmailChangeStatus204Schema;
const confirmEmailChangeDataSchema = confirmEmailChangeBodySchema.describe("Подтверждение смены email");
//#endregion
//#region src/__generated__/external/profile/zod/applicantProfileResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const applicantProfileResponseSchema = z.object({
	contactPhone: z.string().nullish().describe("Контактный телефон"),
	corporateEmail: z.string().nullish().describe("Корпоративная почта"),
	email: z.string().nullish().describe("Email учётной записи").meta({ examples: ["ivanov@example.com"] }),
	firstName: z.string().nullish().describe("Имя").meta({ examples: ["Иван"] }),
	lastName: z.string().nullish().describe("Фамилия").meta({ examples: ["Иванов"] }),
	middleName: z.string().nullish().describe("Отчество").meta({ examples: ["Иванович"] }),
	organization: z.string().nullish().describe("Организация"),
	position: z.string().nullish().describe("Должность"),
	registrationDate: z.iso.datetime().nullish().describe("Дата регистрации в Keycloak")
}).describe("Профиль заявителя: регистрационные данные (Keycloak) + рабочие данные (ВТУ)");
//#endregion
//#region src/__generated__/external/profile/zod/getProfileSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getProfileStatus200Schema = applicantProfileResponseSchema.describe("Профиль заявителя: регистрационные данные (Keycloak) + рабочие данные (ВТУ)");
const getProfileResponseSchema = getProfileStatus200Schema;
//#endregion
//#region src/__generated__/external/profile/zod/requestEmailChangeBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestEmailChangeBodySchema = z.object({ newEmail: z.email().min(1).describe("Новый адрес электронной почты") }).describe("Запрос на смену email");
//#endregion
//#region src/__generated__/external/profile/zod/requestEmailChangeSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestEmailChangeStatus204Schema = z.unknown();
const requestEmailChangeResponseSchema = requestEmailChangeStatus204Schema;
const requestEmailChangeDataSchema = requestEmailChangeBodySchema.describe("Запрос на смену email");
//#endregion
//#region src/__generated__/external/profile/zod/updateProfileRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateProfileRequestSchema = z.object({
	contactPhone: z.string().min(0).max(50).optional().describe("Контактный телефон"),
	corporateEmail: z.email().min(0).max(255).optional().describe("Корпоративная почта"),
	organization: z.string().min(0).max(500).optional().describe("Организация"),
	position: z.string().min(0).max(255).optional().describe("Должность")
}).describe("Обновление рабочих данных профиля заявителя (ФИО фронт обновляет в Keycloak)");
//#endregion
//#region src/__generated__/external/profile/zod/updateProfileSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateProfileStatus200Schema = applicantProfileResponseSchema.describe("Профиль заявителя: регистрационные данные (Keycloak) + рабочие данные (ВТУ)");
const updateProfileResponseSchema = updateProfileStatus200Schema;
const updateProfileDataSchema = updateProfileRequestSchema.describe("Обновление рабочих данных профиля заявителя (ФИО фронт обновляет в Keycloak)");
//#endregion
export { requestEmailChangeDataSchema as a, requestEmailChangeBodySchema as c, applicantProfileResponseSchema as d, confirmEmailChangeDataSchema as f, confirmEmailChangeBodySchema as h, updateProfileRequestSchema as i, getProfileResponseSchema as l, confirmEmailChangeStatus204Schema as m, updateProfileResponseSchema as n, requestEmailChangeResponseSchema as o, confirmEmailChangeResponseSchema as p, updateProfileStatus200Schema as r, requestEmailChangeStatus204Schema as s, updateProfileDataSchema as t, getProfileStatus200Schema as u };

//# sourceMappingURL=updateProfileSchema.js.map